<template>
    <div v-if="visible" class="confirm-prompt-overlay" @click="$emit('cancel')">
        <div class="confirm-prompt-card" @click.stop>
            <div class="confirm-prompt-header">
                <h4>{{ title }}</h4>
            </div>
            <div class="confirm-prompt-body">
                <p>{{ message }}</p>
                <p v-if="note">{{ note }}</p>
            </div>
            <div class="confirm-prompt-actions">
                <button @click="$emit('confirm')" class="btn confirm-prompt-confirm" :class="confirmVariant">
                    {{ confirmLabel }}
                </button>

                <button @click="$emit('cancel')" class="confirm-prompt-cancel">
                    {{ cancelLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ConfirmPrompt',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
        // second line, for a warning the message itself should not carry
        note: {
            type: String,
            default: ''
        },
        confirmLabel: {
            type: String,
            default: 'Confirm'
        },
        cancelLabel: {
            type: String,
            default: 'Cancel'
        },
        confirmVariant: {
            type: String,
            default: 'btn-primary'
        }
    }
}
</script>

<style scoped>
/* mirrors UpdatePrompt.vue so both overlays read as the same dialog */
.confirm-prompt-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.confirm-prompt-card {
    background: #1c1c1c;
    border: 1px solid #2c2c2c;
    border-radius: 14px;
    padding: 18px 16px 8px;
    max-width: 350px;
    width: 90%;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
}

.confirm-prompt-header h4 {
    margin: 0 0 6px 0;
    color: #fff;
    font-size: 17px;
    font-weight: 600;
}

.confirm-prompt-body p {
    margin: 0 0 6px 0;
    color: #c9cdd1;
    font-size: 14px;
    line-height: 1.4;
}

.confirm-prompt-confirm {
    display: block;
    width: 100%;
    height: 46px;
    margin-top: 12px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
}

.confirm-prompt-cancel {
    display: block;
    width: 100%;
    height: 42px;
    margin-top: 4px;
    border: 0;
    background: none;
    color: #9aa0a6;
    font-size: 15px;
}
</style>
